import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "windSpeed";
const UNIT = "km/hr";

const WindSpeed: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default WindSpeed;
